import React from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Common/Header/Header";
import Footer from "../../components/Common/Footer";
import "./BarCouncil.css";

const BarCouncil = () => {
  return (
    <>
      <Header />
      <div className="container ">
        {/* card */}
        <div className="middle-container">
          <div className="middle-part">
            <div
              data-aos="fade-right"
              style={{
                border: "1px solid #ccdbfd",
                borderRadius: "10px",
                backgroundImage: "url(/assets/images/barCouncil-background.png)",
                backgroundRepeat: "no-repeat",
                height: "250px",
                paddingTop: "20px",
                marginRight: "30px",
                width: "100%",
              }}
            >
              <h3 className="text-center">Entry Level Course</h3>
              <div
                style={{
                  padding: "30px",
                  fontSize: "15px",
                  marginTop: "10px",
                }}
              >
                <li style={{ marginBottom: "10px" }}>
                  <Link to={`/lower-court-sr?data=${JSON.stringify("MCQ Exam Preparation")}`}>
                    <span> MCQ Exam Preparation</span>
                  </Link>
                </li>
                <li style={{ marginBottom: "10px" }}>
                  <Link to={`/lower-court-sr?data=${JSON.stringify("Written Exam Preparation")}`}>
                    <span> Written Exam Preparation</span>
                  </Link>
                </li>
                <li style={{}}>
                  <Link to={`/lower-court-sr?data=${JSON.stringify("Viva Exam Preparation")}`}>
                    <span> Viva Exam Preparation</span>
                  </Link>
                </li>
              </div>
              {/* <div className="col-12 text-center">
                <Link to={"/lower-court-sr"}>
                  <Button title={"Apply Now"}></Button>
                </Link>
              </div> */}
            </div>

            <div
           data-aos="fade-left"
              style={{
                border: "1px solid #ccdbfd",
                borderRadius: "10px",
                backgroundImage: "url(/assets/images/barCouncil-background2.png)",
                backgroundRepeat: "no-repeat",
                height: "250px",
                paddingTop: "20px",
                width: "100%",
              }}
            >
              <h3 className="text-center">HCD Written Permission Course</h3>
              <div style={{ padding: "30px", fontSize: "15px", marginTop: "10px" }}>
                <li style={{ marginBottom: "10px" }}>
                  <Link to={`/high-court-sr?data=${JSON.stringify("Written Exam Preparation")}`}>
                    <span> Written Exam Preparation</span>
                  </Link>
                </li>
                <li>
                  <Link to={`/high-court-sr?data=${JSON.stringify("Viva Exam Preparation")}`}>
                    <span> Viva Exam Preparation</span>
                  </Link>
                </li>
              </div>
              {/* <div className="col-12 text-center">
                <Link to={"/lower-court-sr"}>
                  <Button title={"Apply Now"}></Button>
                </Link>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BarCouncil;
